import React from 'react';

const RadialChartIcon = ({ size }: { size: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height="62"
      fill="none"
      viewBox="0 0 80 56"
    >
      <path
        stroke="#C7D2FE"
        strokeWidth="0.8"
        d="m40 20.74 6.9 5.02-2.63 8.11h-8.54l-2.63-8.11z"
      ></path>
      <path
        stroke="#C7D2FE"
        strokeWidth="0.8"
        d="m40 13.48 13.81 10.03-5.28 16.24H31.47l-5.28-16.24z"
      ></path>
      <path
        stroke="#C7D2FE"
        strokeWidth="0.8"
        d="m40 6 20.92 15.2-7.99 24.6H27.07l-7.99-24.6zM40 28V6M40 28l20.92-6.8M40 28l12.93 17.8M40 28 27.07 45.8M40 28l-20.92-6.8"
      ></path>
      <path
        fill="#3B82F6"
        fillOpacity="0.125"
        stroke="#3B82F6"
        strokeWidth="1.5"
        d="m40 11.5 15.69 11.4-5.99 18.45H30.3L24.31 22.9z"
      ></path>
      <path
        fill="#818CF8"
        fillOpacity="0.125"
        stroke="#818CF8"
        strokeWidth="1.5"
        d="m40 17 10.46 7.6-3.99 12.3H33.53l-3.99-12.3z"
      ></path>
    </svg>
  );
};

export default RadialChartIcon;
